import { Link, useLocation } from 'react-router-dom';
import { salesOpportunityPath, type SalesReturnState } from '@/lib/sales-workspace';

export interface DealLinkProps {
  readonly dealId: string;
  readonly className?: string;
  readonly children: React.ReactNode;
}

/**
 * A link to a deal's page that remembers the view it was opened from (rep,
 * tab, stage), so the deal's back arrow returns there.
 */
export function DealLink({ dealId, className, children }: DealLinkProps): React.ReactElement {
  const location = useLocation();
  const state: SalesReturnState = { from: `${location.pathname}${location.search}` };
  return (
    <Link to={salesOpportunityPath(dealId)} state={state} {...(className ? { className } : {})}>
      {children}
    </Link>
  );
}
